'use client';

import { useEffect } from 'react';

import { useAppDispatch } from '@/hooks/use-app-dispatch';
import { setSubdomain, setUser } from '@/store';

const Init: React.FC<{ subdomain: string; user: CustomerPortalUser }> = ({ subdomain, user }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSubdomain(subdomain));
    dispatch(setUser(user));
  }, []);

  return null;
};

export default Init;
